import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-revenue-pay-account',
  templateUrl: './revenue-pay-account.component.html',
  styleUrls: ['./revenue-pay-account.component.css']
})
export class RevenuePayAccountComponent implements OnInit {

  //iframe version
  maximized = false
  iframe_url: any;
  urlSafe!: SafeResourceUrl;

  iframe_type = 'revenue_payaccount'
  iframe_data: any;
  iframe_form = new FormGroup({
    year: new FormControl(''),
    iframe: new FormControl('', [Validators.required]),
    edit: new FormControl('', [Validators.required]),
    type: new FormControl('')
  });
  
  constructor(
    public services: ApiService,
    public sanitizer: DomSanitizer,
  ) { }

  async ngOnInit(): Promise<void> {
    document.getElementById('receivables')!.classList.toggle("active");
    document.getElementById('receivable')!.classList.toggle("show");
    document.getElementById('revenue_payaccount')!.classList.toggle("active");

    await this.setIframe()
  }

  ngOnDestroy(){
    document.getElementById('receivables')!.classList.remove("active");
    document.getElementById('receivable')!.classList.remove("show");
    document.getElementById('revenue_payaccount')!.classList.remove("active");
  }

  async setIframe() {
    let arr_iframe = [] as any
    await this.services.get('m_iframe_url').then((res: any) => {
      arr_iframe = res.filter((f: any) => {
        f.id = Number(f.id)
        if (f.type == this.iframe_type) {
          if (f.iframe) {
            f.iframe = JSON.parse(f.iframe)
            f.iframe_url = f.iframe.join("'");
          }
          if (f.edit) {
            f.edit = JSON.parse(f.edit)
            f.edit_url = f.edit.join("'");
          }
        }
        return f.type == this.iframe_type
      })
    })
    if (arr_iframe.length > 0) {
      arr_iframe = arr_iframe.sort((a: any, b: any) => (a.id > b.id) ? -1 : ((b.id > a.id) ? 1 : 0))
      this.iframe_data = arr_iframe[0]
      this.iframe_url = this.iframe_data.iframe_url;
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_url);
    }
  }
  goToEdit(): void {
    if (this.iframe_data) {
      window.open(this.iframe_data.edit_url, "_blank");
    }
  }
  addIframe() {
    this.iframe_form.patchValue({
      type: this.iframe_type,
      iframe: JSON.stringify(this.iframe_form.value.iframe.split("'")),
      edit: JSON.stringify(this.iframe_form.value.edit.split("'")),
      year: ''
    })

    this.services.create('m_iframe_url', this.iframe_form.value).then((res: any) => {
      if (res) {
        this.setIframe()
        this.iframe_form.reset()
        $('#updateURL_ht').modal('hide');
        Swal.fire({
          title: 'อัพเดต URL สำเร็จ',
          icon: 'success',
          confirmButtonText: `ตกลง`,
          showConfirmButton: false,
          timer: 1500
        })

      }
    })
  }
  
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    // document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }
  maximizeorMinimize(table_name:any, btn_name:any){
    var table = document.getElementById(table_name);
    var btn = document.getElementById(btn_name);
    if (!this.maximized) {
      table!.style.position = 'fixed';
      table!.style.zIndex = '99';
      table!.style.background = 'white';
      table!.style.width = "100vw";
      table!.style.height = "85vh";
      table!.style.top = "12%";
      table!.style.left = "0";
      btn!.setAttribute('src', "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///8AAADo6OgwMDB0dHTCwsI3NzdwcHAgICDU1NRhYWGWlpZLS0va2tqSkpLHx8e5ublZWVknJyfe3t5BQUGjo6NmZmYXFxf19fVTU1NcXFympqavr68YGBgODg62trZ7e3vm1eqLAAACtUlEQVR4nO3d7VLiQBBGYT5CICQIsqIssuj9X+UWtaXlTK2ka7rdd9Y6zwUMc0xiBn/YkwkAAAAAAAAAAMB/aNs3QzvXaoem335N3mI9rcd6Ed53uKijMpdDaF+3Ugf9xX4TF3injvlEHxVY0wOYeowJfFB33DBEBNZ7Ba8CrmKtz+Ab97PYqQtGeX+j7tUBo1pf4LN6/wZnV6F69xYrT+CLevcmnjPqkC922nUzrW53n29qXR54zJba/3D8tOJs8lNy+VKLdKHVMW6XLsfsi05XvFL2tq/jCl5lb+nyt356YHPc7uF+Jjt7LV6nTdbZhe3P75zsrPz8Pa/0Js1v0/JjTVo4C9yh1yzZ2bx4HQp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCKwp1KLSiUIdCK3tht4h367+S/vvC5TTesqrC5gsKGwoppJBCCimkkEIKgwu//7n0sGyiLW8NVuP7oRWFOhRaUahDoRWFOhRaUahDoRWFOhRaUahDoRWFOlGF6YRH73joSJtkZ+XzD9O58S+BO/RKBxU/FK+T/p33FLhDr3Qm8K2/Hd/WJ+tUNKYzvUkds2S36UL1zAN+Sje2LV8qXegbznTOxu5OK53Lfe8o3OWLVckzW31yGV9f7pcnMJudXKezq3CyV+9/VPmR7Y9u/CPE3IfJu/HPkCp/279bj3+K0KM/MD9/16V8bnyi3qsYcgWvan0WA57BN11+EqzBPvYr+UHdk3t6Du272p3UUR+sXWfRz237ZmjnWu3Q9I7vgwAAAAAAAAAAADq/AeDROLr9IlTcAAAAAElFTkSuQmCC");
      btn!.style.width = "30px";
      btn!.style.height = "30px";
      btn!.style.marginRight = "15px";
      btn!.title = "Minimize";
      this.maximized = true;
    } else {
      table!.style.position = 'relative';
      table!.style.zIndex = '5';
      table!.style.width = "100%";
      table!.style.height = "100vh";
      table!.style.top = "0%";
      table!.style.borderRadius = "15px";
      btn!.title = "Maximize";
      btn!.style.width = "15px";
      btn!.style.height = "15px";
      btn!.style.marginRight = "5px";
      btn!.style.marginTop = "5px";
      btn!.setAttribute('src', "https://cdn2.iconfinder.com/data/icons/mixed-vol-7/74/Untitled-1-11-08-07-17-512.png");
      this.maximized = false;
    }
  }
}
